import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const InpcListHeader = ({ canAdd = false, companyId = '', t }) => {
  return (
    <Common.Header title={t('inpc.inpc_title')}>
      <div className="btn-group pull-right">
        {canAdd && (
          <Form.Link to={`/companies/${companyId}/inpc/add`} className="btn btn-info">
            {t('actions.add')}
          </Form.Link>
        )}
      </div>
    </Common.Header>
  );
};

export default translate()(InpcListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/list/InpcListHeader.js